module.exports = __webpack_public_path__ + "static/konradova-prodavaonica-ptica-b466a7fc1dc70928aad761d0320f1de6.png";